'use strict';

import './starRatings.scss';
import template from './starRatings.template.html';
import controller from './starRatings.controller.js';

const component = {
    bindings: {
        rating: '@',
        boundRating: '=?',
        reviews: '@',
        dealerId: '@',
        listingId: '@?',
        partyId: '@',
        showCount: '@',
        showRatingText: '@',
        webPageTypeFromId: '=?',
        webPageTypeToId: '=?',
        clickable: '=',
        reviewsUrl: '@',
        allowZero: '@',
        icon: '@',
        starHeight: '@', // in rem
        unratedBarText: '=' //optional override for changing the text when no rating exists
    },
    controller,
    template
};

export default component;
